import { Reducer } from 'redux';
import { ACTION, FailLoadDraftsCount, ReceiveLoadDraftsCount, RequestLoadDraftsCount } from './action-types';
import { CaseDraftInfoState } from './types';

const INITIAL_STATE: CaseDraftInfoState = {
  fetching: false,
  count: 0
};

const reducers = {
  [ACTION.RequestLoadDraftsCount]: (state: CaseDraftInfoState, action: RequestLoadDraftsCount): CaseDraftInfoState => ({
    ...state,
    fetching: true,
    count: 0
  }),

  [ACTION.ReceiveLoadDraftsCount]: (state: CaseDraftInfoState, action: ReceiveLoadDraftsCount): CaseDraftInfoState => ({
    ...state,
    fetching: false,
    count: action.count
  }),

  [ACTION.FailLoadDraftsCount]: (state: CaseDraftInfoState, action: FailLoadDraftsCount): CaseDraftInfoState => ({
    ...state,
    fetching: false,
    count: 0
  })
} as { [key: string]: Reducer<CaseDraftInfoState> };

export const reducer: Reducer<CaseDraftInfoState> = (state: CaseDraftInfoState = INITIAL_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
